import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.css";
import eilanLogo from "../../Assets/Images/eilanlogo.png";

const TABS = [
  { label: "Showcase", path: "/gallery" },
  { label: "Profile", path: "/Profile" },
  { label: "Clients", path: "/clients" },
];

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const [hideHeader, setHideHeader] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // scrolling down
        setHideHeader(true);
      } else {
        // scrolling up
        setHideHeader(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isActive = (tab) => {
    if (tab.path === "/gallery") {
      return location.pathname === "/gallery" || location.pathname === "/";
    }
    return location.pathname === tab.path;
  };

  return (
    <header className={`header ${hideHeader ? "header--hidden" : ""}`}>
      <div className="header-inner">
        <div
          className="header-logo"
          onClick={() => navigate("/gallery")}
          style={{ cursor: "pointer" }}
        >
          <img
            src={eilanLogo}
            alt="Eilan Digital"
            className="header-logo-img"
          />
        </div>

        <nav className="header-nav" aria-label="Page sections">
          {TABS.map((tab) => (
            <button
              key={tab.path}
              className={`header-pill${
                isActive(tab) ? " header-pill--active" : ""
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}